import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  ngUserListRequest,
  ngUserAddRequest,
  ngUserRemoveRequest
} from 'actions/clients';
import { getClientNgUsersById } from 'selectors/lists';
import { isClientNgUserLoading } from 'selectors/loading';

import ClientUserPreferenceHOC from './ClientUserPreferenceHOC';
import ClientUserPreference from './presenter';


const mapStateToProps = (state, props) => {
  const id = props.clientId;
  return {
    title: "NG User",
    preferences: getClientNgUsersById(state, id),
    isLoading: isClientNgUserLoading(state, id)
  }
}

const mapDispatchToProps = (disptach) => {
  return bindActionCreators({
    listRequest: ngUserListRequest,
    addRequest: ngUserAddRequest,
    removeRequest: ngUserRemoveRequest,
  }, disptach)
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClientUserPreferenceHOC(ClientUserPreference));
